import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ViewComplainSupportTeam from "./viewComplainSupportTeam";
import {
  complainRaisedTicket,
  closeComplain,
  viewDetails,
  reopenComplain,
  saveComplaintReplySupport,
  saveAssigneeDetails,
  subIssueDropdown
} from "services/redux/fileComplain/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { calculateDistance, getDistanceData, getSiteData } from 'services/redux/DistanceCalculator/action';

const mapStateToProps = (state) => ({
    complainList: state.fileComplainReducer.fetchComplain,
    viewComplainDetails: state.fileComplainReducer.viewComplain,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    getSubIssueDropdown: state.fileComplainReducer.getSubIssueDropdown,
    distanceData: state.leadDataReducer.distanceDetails,
    siteData: state.leadDataReducer.siteData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    closeComplain,
    reopenComplain,
    viewDetails,
    complainRaisedTicket,
    saveComplaintReplySupport,
    documentUploadUrlPublic,
    saveAssigneeDetails,
    subIssueDropdown,
    calculateDistance,
    getDistanceData,
    getSiteData,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewComplainSupportTeam);
